import React, { useState } from 'react';
import CONSTANTS from '../../assets/constants';
import infoIcon from '../../assets/Images/infoIcon.svg';
import InformationModal from './informationModal';

const InformationButton = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className="grid-container">
      <InformationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      />

      <div className="grid-x align-right">
        <button
          onClick={() => setModalOpen(true)}
          className="information-button shadow margin-top-2"
        >
          <img src={infoIcon} alt="Information Button" />
          <span className="padding-right-1">
            {CONSTANTS.INFORMATION_BUTTON}
          </span>
        </button>
      </div>
    </div>
  );
};

export default InformationButton;
